
import LeadFinder from "./LeadFinder";
import "./index.css";



export function App() {
  return (
    <div className="app">
      <div className="logo-container">
        
      </div>

          <LeadFinder />

      <hr style={{ margin: "2rem 0" }} />

      
      
    </div>
  );
}

export default App;
